module.exports = __webpack_public_path__ + "static/studying-434bce1e352bd431a2fd3dcdee2cd06f.svg";